import { Lock, Sparkles, Layers } from "lucide-react";
import { E } from "@/components/EditableText";
import GuardianConsole from "@/components/guardian/GuardianConsole";
import { SUN_DEEP } from "@/components/guardian/pricing/config";

const PILLARS = [
  {
    Icon: Lock,
    t: "Your own protected environment",
    b: "State-of-the-art security by design. Each company's data lives in its own protected environment with the latest safeguards — so you get the full picture without anyone's data going where it shouldn't.",
  },
  {
    Icon: Sparkles,
    t: "Flexible and intuitive",
    b: "Built around how you work, not the other way around. Ask a plain-language question across every company and get a clear answer — no training, no manual, no waiting on a report.",
  },
  {
    Icon: Layers,
    t: "Multi-tenant by design",
    b: "One login, every company you oversee — each fully walled off from the next. You see health and posture across the whole book; the privileged legal detail stays with each company where it belongs.",
  },
];

export function DashboardMock() {
  return (
    <section id="dashboard" className="px-6 md:px-12 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <p className="pcp-mono text-[11px] mb-4" style={{ color: SUN_DEEP }}>/ 07 · What the manager sees — Guardian Portfolio</p>
        <h2 className="pcp-h text-4xl md:text-5xl mb-4 max-w-4xl">
          <E k="dashboard.headline" defaultText="Quickly See Each Company's Compliance Story" as="span" multiline />
        </h2>
        <p className="text-base md:text-lg opacity-80 max-w-3xl mb-8">
          <E
            k="dashboard.intro"
            defaultText="A working prototype — not a screenshot. Resolve an item, toggle a module, ask CompliMind a portfolio-wide question, and watch the report card recalculate. Posture only. Privileged legal content stays with the company-client."
            as="span"
            multiline
          />
        </p>

        <GuardianConsole />

        <div className="grid md:grid-cols-3 gap-5 mt-8">
          {PILLARS.map(({ Icon, t, b }) => (
            <div key={t} className="pcp-card p-5">
              <Icon className="h-5 w-5 mb-2" style={{ color: SUN_DEEP }} strokeWidth={1.6} />
              <div className="font-semibold mb-1">{t}</div>
              <p className="text-sm opacity-75">{b}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
